<form [formGroup]="settingsForm">
  <efp-list-header [topPadding]="false">
    <ion-label>{{ 'SETTINGS.GENERAL_SETTINGS' | translate }}</ion-label>
  </efp-list-header>

  <ng-container *ngIf="appSettingsRepository.appSettings$ | async">
    <div class="d-flex-col gap-3">
      <doka-select [label]="'SETTINGS.LANGUAGE' | translate" formControlName="language">
        <doka-select-option
          *ngFor="let item of appLanguages"
          [value]="item"
          [label]="'LANGUAGE.' + item | translate"></doka-select-option>
      </doka-select>

      <div class="form-container d-flex-responsive-wrap d-flex-responsive-gap flex-col">
        <div class="label-container flex-1 d-flex">
          <span class="select-label">{{ 'SETTINGS.COUNTRY' | translate }}</span>
        </div>
        <div class="flex justify-between flex-1 items-center">
          <span *ngIf="country$ | async as country">
            {{ 'COUNTRY.' + country.toUpperCase() | translate }}
          </span>
          <button
            *ngIf="!isDoka360Scope"
            class="button button-secondary"
            (click)="presentPrivacyPolicyModal()">
            {{ 'LEGAL_MODAL.CHANGE_COUNTRY_BUTTON' | translate }}
          </button>
        </div>
      </div>

      <div class="form-container d-flex-responsive-wrap d-flex-responsive-gap">
        <efp-toggle-cell
          [title]="'SETTINGS.DEVICE_MODE.TITLE' | translate"
          [description]="'SETTINGS.DEVICE_MODE.DESCRIPTION' | translate"
          [checked]="!!isNative()"
          (checkedChanged)="toggleNativeMode()"
          data-test-selector="appsettings-toggle-device_mode">
        </efp-toggle-cell>
      </div>
      <div
        class="d-flex form-container d-flex-responsive-wrap d-flex-responsive-gap"
        *ngIf="isNative()">
        <efp-toggle-cell
          (checkedChanged)="toggleShowSync()"
          [title]="'SETTINGS.SHOW_SYNC_STATE' | translate"
          [checked]="this.settingsForm.controls.showSyncIndicator.value"
          [boldLabelStyle]="true"
          data-test-selector="appsettings-toggle-show-sync-state">
        </efp-toggle-cell>
      </div>
    </div>
  </ng-container>
</form>
